import React from "react";
import {Tenant} from "models/Tenant";
import {Card, CardBody} from 'reactstrap';
import CardHeader from "components/CardHeader";
import {User} from "models/User";
import {RootState} from "store/store";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {addUserToTenant, deleteUserFromTenant} from "store/actions/Tenants";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

interface Props {
    tenant: Tenant;
    users: User[];
}


interface Actions {
    addUserToTenant: (userId: string, tenantId: string) => void;
    deleteUserFromTenant: (userId: string, tenantId: string) => void;

}

const TenantUsers: React.FC<Props & Actions> = ({ users, tenant, addUserToTenant, deleteUserFromTenant }) => {
    const {t} = useOfficeTranslation();
    const sortedUsers = [...users].sort((a, b) => a.name.localeCompare(b.name));
    const assignedCount = sortedUsers.filter(user => user.accounts.includes(tenant.id)).length;

    return (
        <Card>
            <CardBody>
                <CardHeader title={t("common.users")} icon="mdi-account-multiple-outline" count={assignedCount} />
                {sortedUsers.length === 0
                    ? <p className="text-muted mt-3 mb-0">{t("tenants.tenantUsers.noUsersAvailable")}</p>
                    : sortedUsers.map(user => {
                        const assigned = user.accounts.includes(tenant.id);
                        return <div key={user.id} className="d-flex justify-content-between align-items-center gap-3 border-bottom py-3">
                            <label className="mb-0" htmlFor={`tenant-user-${user.id}`}>
                                <span className="d-block fw-medium">{user.name}</span>
                                <small className="text-muted">{user.email}</small>
                            </label>
                            <input
                                id={`tenant-user-${user.id}`}
                                className="form-check-input mt-0"
                                type="checkbox"
                                checked={assigned}
                                onChange={() => assigned
                                    ? deleteUserFromTenant(user.id, tenant.id)
                                    : addUserToTenant(user.id, tenant.id)}
                            />
                        </div>;
                    })}
            </CardBody>
        </Card>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({ addUserToTenant, deleteUserFromTenant }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantUsers);
